var Sortable =
/** @class */
function () {
  function Sortable() {
    /**
     * need to re-sort
     */
    this.dirty = false;
    /**
     * render order in whole scenegraph
     */

    this.renderOrder = 0;
  }

  Sortable.tag = 'c-sortable';
  return Sortable;
}();

export { Sortable };